function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameObserverLoader = require('./game-observer-loader');
var GameObserverHUD = require('./game-observer-hud');
var Transaction = require('../../transaction')["default"];

/**
 * An interface for a third party to trace the moves of a game step-by-step
 *
 */
var GameObserver = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param app - the Saito Application
   */
  function GameObserver(app, game_mod) {
    _classCallCheck(this, GameObserver);
    this.app = app;
    this.game_mod = game_mod;

    //
    // playback
    //
    this.playback_status = 'init';
    this.playback_speed = 2000;
    this.playback_timer = null;
    this.is_downloading = false;
    this.download_timer = null;
    this.latest_step = 0;

    //
    // game transactions
    //
    this.txs = [];
    this.tx_hashmap = {};
    this.buffer = [];
    this.snapshots = [];
    this.index_max = 0;
    this.index_current = 0;
    this.index_range = 20;
    this.loader = new GameObserverLoader(app, game_mod);
    this.hud = new GameObserverHUD(app, this);
    this.playback_timer_active = false;
    this.playback_timer = null;
  }
  return _createClass(GameObserver, [{
    key: "updateStatus",
    value: function updateStatus(message) {
      if (this.hud && this.hud.updateStatus) {
        this.hud.updateStatus(message);
      }
      if (this.loader && this.loader.updateStatus) {
        this.loader.updateStatus(message);
      }
    }

    /**
     * Observer-only initialization: resolve or create game, assign to game_mod.game,
     *
     * observers may not have a copy of the local game, so we create a stub that can hold
     * the game state and the game moves, such that the observer can load the game movecs
     * into its queue and have it execute the game appropriately.
     *
     */
  }, {
    key: "initialize",
    value: function initialize(game_id) {
      var _this = this;
      var game = this.game_mod.loadGame(game_id);
      if (!game) {
        this.game_mod.game = {
          id: game_id,
          future: [],
          queue: [],
          step: {
            game: 0,
            players: {}
          },
          players: [],
          player: 0,
          originator: ''
        };
        if (typeof this.game_mod.normalizeGameShape === 'function') {
          this.game_mod.normalizeGameShape(this.game_mod.game);
        }
      }
      if (this.app.BROWSER) {
        this.playback_timer = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var _this$game_mod;
          var tx;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(_this.player_timer_active == true)) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                _this.playback_timer_active = true;
                console.log('playback timer...');
                if (!(_this.playback_status !== 'playing')) {
                  _context.n = 2;
                  break;
                }
                return _context.a(2);
              case 2:
                if ((_this$game_mod = _this.game_mod) !== null && _this$game_mod !== void 0 && _this$game_mod.game) {
                  _context.n = 3;
                  break;
                }
                return _context.a(2);
              case 3:
                if (!(_this.game_mod.halted === 1)) {
                  _context.n = 4;
                  break;
                }
                return _context.a(2);
              case 4:
                if (!(_this.buffer.length === 0)) {
                  _context.n = 5;
                  break;
                }
                return _context.a(2);
              case 5:
                if (!(_this.game_mod.game.future.length > 0)) {
                  _context.n = 6;
                  break;
                }
                return _context.a(2);
              case 6:
                if (!(_this.buffer.length > 0)) {
                  _context.n = 7;
                  break;
                }
                tx = _this.buffer.shift();
                _this.game_mod.game.future.push(tx.serialize_to_web ? tx.serialize_to_web(_this.app) : tx);
                if (!_this.game_mod.processFutureMoves()) {
                  _context.n = 7;
                  break;
                }
                _context.n = 7;
                return _this.game_mod.runQueue();
              case 7:
                _this.playback_timer_active = false;
              case 8:
                return _context.a(2);
            }
          }, _callee);
        })), this.playback_speed);
      }
      this.game_mod.game.player = 0;
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loader.render();
              this.hud.render();

              //
              // check status
              //
              if (this.playback_status === 'init') {
                //
                // download moves
                //
                this.loader.updateStatus("Downloading moves (".concat(this.txs.length, ")"));

                //
                // download timer
                //
                this.download_timer = setInterval(function () {
                  var _this2$game_mod;
                  if (!((_this2$game_mod = _this2.game_mod) !== null && _this2$game_mod !== void 0 && _this2$game_mod.game)) {
                    return;
                  }
                  _this2.download(_this2.game_mod.game.id);
                }, 3000);
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "download",
    value: function () {
      var _download = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(game_id) {
        var _this$game_mod2,
          _this3 = this;
        var limit, cursor;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if ((_this$game_mod2 = this.game_mod) !== null && _this$game_mod2 !== void 0 && _this$game_mod2.game) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, null);
            case 1:
              if (!this.is_downloading) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, null);
            case 2:
              if (this.game_mod.archive_connected) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, null);
            case 3:
              this.is_downloading = true;
              limit = 20;
              cursor = this.latest_step;
              this.app.storage.loadTransactions({
                field1: this.game_mod.name,
                field4: game_id,
                field5: cursor,
                field5_sort: 1,
                ascending: 1,
                limit: limit
              }, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(txs) {
                  var new_tx_found, _iterator, _step, _tx, sig, _msg$step$game, _msg$step, msg, step, _this3$hud, _iterator2, _step2, tx, _t;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        new_tx_found = false;
                        _iterator = _createForOfIteratorHelper(txs || []);
                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            _tx = _step.value;
                            sig = _tx.signature != null ? _tx.signature : _tx.hash;
                            if (!_this3.tx_hashmap[sig]) {
                              _this3.txs.push(_tx);
                              _this3.tx_hashmap[sig] = _this3.txs.length - 1;
                              new_tx_found = true;
                              try {
                                msg = _tx.returnMessage ? _tx.returnMessage() : _tx.msg || null;
                                step = (_msg$step$game = msg === null || msg === void 0 || (_msg$step = msg.step) === null || _msg$step === void 0 ? void 0 : _msg$step.game) !== null && _msg$step$game !== void 0 ? _msg$step$game : 0;
                                if (step > _this3.latest_step) _this3.latest_step = step;
                              } catch (e) {}
                              if (_this3.playback_status === 'playing') {
                                _this3.buffer.push(_tx);
                              }
                            }
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }
                        if (new_tx_found) {
                          _this3.index_max = _this3.txs.length;
                          if ((_this3$hud = _this3.hud) !== null && _this3$hud !== void 0 && _this3$hud.setRange) {
                            _this3.hud.setRange(0, _this3.index_max);
                          }
                        }
                        if (!(txs && txs.length === limit && new_tx_found)) {
                          _context3.n = 1;
                          break;
                        }
                        _this3.loader.updateStatus('Fetching more moves...');
                        _this3.is_downloading = false;
                        _this3.download(game_id);
                        return _context3.a(2);
                      case 1:
                        if (!(_this3.playback_status === 'init')) {
                          _context3.n = 5;
                          break;
                        }
                        console.log('#');
                        console.log('#');
                        console.log('#');
                        console.log('PLAYBACK STATUS IS INIT!!!!');
                        _context3.n = 2;
                        return _this3.game_mod.initializeGameQueue(_this3.game_mod.game.id);
                      case 2:
                        _this3.game_mod.initialize_game_run = 1;
                        _context3.n = 3;
                        return _this3.game_mod.runQueue();
                      case 3:
                        _t = _context3.v;
                        if (!(_t == 0)) {
                          _context3.n = 4;
                          break;
                        }
                        _this3.game_mod.processFutureMoves();
                      case 4:
                        console.log('###');
                        console.log('###');
                        console.log('###');
                        console.log('AFTER INITIALIZE GAME RUN CHECKED...');
                        _this3.game_mod.halted = 0;

                        // snapshot the fully initialized baseline
                        _this3.snapshots = [];
                        console.log('OBSERVER SNAPSHOT CHECK DECK:', _this3.game_mod.game.deck);
                        _this3.snapshots.push(JSON.stringify(_this3.game_mod.game));

                        // now replay all moves
                        _iterator2 = _createForOfIteratorHelper(_this3.txs);
                        try {
                          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                            tx = _step2.value;
                            _this3.game_mod.game.future.push(tx.serialize_to_web ? tx.serialize_to_web(_this3.app) : tx);
                          }

                          //this.game_mod.saveFutureMoves(this.game_mod.game.id);
                          //this.game_mod.saveGame(this.game_mod.game.id);

                          //while (true) {
                          //  if (this.game_mod.processFutureMoves()) {
                          //    await this.game_mod.runQueue();
                          //    continue;
                          //  }
                          //  break;
                          //}
                        } catch (err) {
                          _iterator2.e(err);
                        } finally {
                          _iterator2.f();
                        }
                        _this3.readyToObserve();
                      case 5:
                        if (_this3.playback_status === 'playing' || _this3.playback_status === 'paused') {
                          _this3.is_downloading = false;
                        }
                      case 6:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function download(_x) {
        return _download.apply(this, arguments);
      }
      return download;
    }()
  }, {
    key: "readyToObserve",
    value: function readyToObserve() {
      var _this$hud;
      this.index_max = this.txs.length;
      this.index_current = this.index_max;
      if ((_this$hud = this.hud) !== null && _this$hud !== void 0 && _this$hud.setRange) {
        this.hud.setRange(0, this.index_max);
        this.hud.setPosition(this.index_current);
      }
      this.loader.updateStatus('Game Synchronized...');
      this.hud.updateStatus('Press Play to Observe');
      this.loader.remove();
      this.playback_status = 'paused';
    }
  }, {
    key: "getMovesInRange",
    value: function getMovesInRange() {
      var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000;
      var moves = [];
      var _iterator3 = _createForOfIteratorHelper(this.txs),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _msg$step$game2, _msg$step2;
          var tx = _step3.value;
          var msg = tx.returnMessage();
          var step = (_msg$step$game2 = msg === null || msg === void 0 || (_msg$step2 = msg.step) === null || _msg$step2 === void 0 ? void 0 : _msg$step2.game) !== null && _msg$step$game2 !== void 0 ? _msg$step$game2 : 0;
          if (step >= min && step <= max) {
            moves.push(tx);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return moves;
    }
  }, {
    key: "replayToIndex",
    value: function () {
      var _replayToIndex = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(targetIndex) {
        var _this$hud2;
        var baseline, maxIndex, clamped, replayMoves, _iterator4, _step4, tx;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.playback_status = 'paused';
              if (!(!this.snapshots || !this.snapshots[0])) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              baseline = JSON.parse(this.snapshots[0]);
              maxIndex = Math.max(0, this.txs.length);
              clamped = Math.max(0, Math.min(targetIndex, maxIndex));
              this.loader.render();
              _context5.n = 2;
              return new Promise(function (resolve) {
                return requestAnimationFrame(resolve);
              });
            case 2:
              this.buffer = [];
              this.game_mod.game = baseline;
              this.game_mod.game.future = [];
              this.game_mod.game.queue = [];
              this.game_mod.halted = 0;
              this.game_mod.gaming_active = 0;
              _context5.n = 3;
              return this.game_mod.initializeGameQueue(this.game_mod.game.id);
            case 3:
              replayMoves = this.txs.slice(0, clamped);
              _iterator4 = _createForOfIteratorHelper(replayMoves);
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  tx = _step4.value;
                  this.game_mod.game.future.push(tx.serialize_to_web ? tx.serialize_to_web(this.app) : tx);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            case 4:
              if (!true) {
                _context5.n = 7;
                break;
              }
              if (!this.game_mod.processFutureMoves()) {
                _context5.n = 6;
                break;
              }
              _context5.n = 5;
              return this.game_mod.runQueue();
            case 5:
              return _context5.a(3, 4);
            case 6:
              return _context5.a(3, 7);
            case 7:
              this.index_current = clamped;
              if ((_this$hud2 = this.hud) !== null && _this$hud2 !== void 0 && _this$hud2.setPosition) {
                this.hud.setPosition(this.index_current);
              }
              this.loader.remove();
              this.hud.updateStatus("Paused at move ".concat(this.index_current));
            case 8:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function replayToIndex(_x3) {
        return _replayToIndex.apply(this, arguments);
      }
      return replayToIndex;
    }()
  }, {
    key: "startPlayback",
    value: function startPlayback() {
      if (!this.txs || this.txs.length === 0) {
        return;
      }
      this.playback_status = 'playing';
      if (this.index_current < this.txs.length) {
        this.buffer = this.txs.slice(this.index_current);
      }
      if (this.hud && this.hud.updateStatus) {
        this.hud.updateStatus('Playing...');
      }
    }
  }]);
}();
module.exports = GameObserver;